import React  from 'react';
import { Container, Nav, NavItem } from 'reactstrap';

const Footer = () =>(
    <section className="footer">
        <Container>
            <Nav className="justify-content-center">
                <NavItem>
                    <a
                        className="nav-link"
                        href="https://dieta.hpba.pl/contact"
                    >
                        Contact Support
                    </a>
                </NavItem>
                <NavItem>
                    <a
                        className="nav-link"
                        href="https://dieta.hpba.pl/privacy-policy"
                    >
                        Privacy Policy
                    </a>
                </NavItem>
                <NavItem>
                    <a
                        className="nav-link"
                        href="https://dieta.hpba.pl/terms-of-service"
                    >
                        Terms of service
                    </a>
                </NavItem>
            </Nav>
        </Container>
    </section>
);

export default Footer;
